import { Component, inject } from '@angular/core';
import { ENVIRONMENT } from '../environment.token';
import { NonProductionNotice } from '../../environments/environment.model';

@Component({
  selector: 'app-non-production-banner',
  standalone: true,
  templateUrl: './non-production-banner.component.html',
  styleUrl: './non-production-banner.component.css',
})
export class NonProductionBannerComponent {
  private env = inject(ENVIRONMENT);

  /**
   * Tested with `=== true` so a missing or malformed flag fails toward showing the banner
   * in the environment that got it wrong, never toward hiding it from a real customer.
   */
  readonly isProduction = this.env.isProduction === true;

  readonly notice: NonProductionNotice | null = this.isProduction
    ? null
    : this.env.nonProductionNotice;
}
